import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import EventCard from "./event-card2";
import axios from "axios";
import heart from "../../assets/images/shapes/heart-2-1.png";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, EffectFade } from "swiper";


var Api_url = process.env.GATSBY_API_URL;
console.log("API_URL=" + Api_url);

const axiosConfig = {
  headers: {
    "Content-Type": "application/json; text/html; charset=UTF-8",
    "Access-Control-Allow-Origin": "*"
  }
};
class EventHomeTwo extends React.Component {
  constructor() {
    super();
    this.state = {
      LoadingFlag: false,
      TotalRecords: 0,
      Records: [],
      bgImage: Api_url + "/assets/website/images/event-map-1-2.png"
    };
  }
  getAllRecords = async () => {
    console.log("getAllRecords called ");

    var url = Api_url + `/api/programs/events/lists`;
    console.log("url=" + url);
    var postData = {
      UserInterface: 4
    };
    this.setState({ LoadingFlag: true });
    console.log({ postData });
    await axios
      .post(url, postData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        this.setState({ LoadingFlag: false });

        var flag = res.data.flag;
        var records = res.data.records;
        console.log({ records });

        if (flag) {

          var result = records.EventsData;
          var n1 = result.length;
          console.log("n1=" + n1);

          this.setState({ Records: result, TotalRecords: n1 });
        } else {
          this.setState({ hasMore: false });
        }
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  componentDidMount() {
    console.log("componentDidMount called ");
    this.getAllRecords();
  }
  render() {
    if (this.state.TotalRecords > 0) {
      return (
        <section
          className="event-home-two pb-120"
          style={{ backgroundImage: `url(${this.state.bgImage})` }}
        >
          <Container>
            <Row className=" align-items-start align-items-md-center flex-column flex-md-row mb-60">
              <Col lg={12}>
                <div className="block-title">
                  <br /><br />
                  <p>
                    <img src={heart} width="15" alt="" />
                    Featured Programs
                  </p>
                  <h3>
                    Checkout our upcoming programs
                  </h3>
                </div>
              </Col>
              {/* <Col lg={5} className="d-flex">
            <div className="my-auto">
              <p className="block-text pr-10 mb-0">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Have you done google research which works all the
                time.{" "}
              </p>
            </div>
          </Col> */}
            </Row>
            <Swiper
              pagination
              spaceBetween={50}
              breakpoints={{
                1500: {
                  slidesPerView: 2,
                  spaceBetweenSlides: 20
                },
                1200: {
                  slidesPerView: 2,
                  spaceBetweenSlides: 30
                },
                // when window width is <= 800px
                800: {
                  slidesPerView: 1,
                  spaceBetweenSlides: 40
                }
              }}
              autoplay
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              {this.state.Records.map((event, index) => (
                <SwiperSlide>
                  <EventCard data={event} key={`event-card-key-${index}`} />
                </SwiperSlide>
              ))}
            </Swiper>
          </Container>
        </section>
      );
    } else {
      return (
        <section
          className="event-home-two pb-120"
          style={{ backgroundImage: `url(${this.state.bgImage})` }}
        >
          <Container>
            <Row className=" align-items-start align-items-md-center flex-column flex-md-row mb-60">
              <Col lg={12}>
                <div className="block-title">
                  <br /><br />
                  <p>
                    <img src={heart} width="15" alt="" />
                    Featured Programs
                  </p>
                  <h3>
                    Checkout our upcoming programs
                  </h3>
                </div>
              </Col>
              {/* <Col lg={5} className="d-flex">
            <div className="my-auto">
              <p className="block-text pr-10 mb-0">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Have you done google research which works all the
                time.{" "}
              </p>
            </div>
          </Col> */}
            </Row>
            <Row>
              <Col lg={12}>
                No Records Found.
              </Col>
            </Row>
          </Container>
        </section>);
    }
  };
}

export default EventHomeTwo;
